export function isArrayBuffer(data: unknown): data is ArrayBuffer {
  if (!(typeof data === "object" && data !== null)) {
    return false;
  } else if (data.constructor.name === "ArrayBuffer") {
    return true;
  }
  return false;
}

export const USER_CAMERA_STREAM_PB = "USER_CAMERA_STREAM_PB";
export const INFRARED_STREAM_PB = "INFRARED_STREAM_PB";
export const VIDEO_TRACK = "video_track"; // for older mobile app versions
export const DOCK_CAMERA_STREAM_PB = "DOCK_CAMERA_STREAM_PB";
